export default __webpack_public_path__ + "static/media/about1.e642f50e.jpg";